(() => {
  'use strict';

  if (window.__foodnetMobileClarity) return;
  window.__foodnetMobileClarity = true;

  const mobileQuery = window.matchMedia('(max-width: 760px)');
  let buybarObserver = null;
  let fallbackVisibilityHandler = null;
  let mediaChangeHandler = null;
  let buybarSync = null;
  let buybarSyncTimer = 0;

  const scheduleBuybarSync = () => {
    window.clearTimeout(buybarSyncTimer);
    buybarSyncTimer = window.setTimeout(() => {
      window.requestAnimationFrame(() => buybarSync?.());
    }, 0);
  };

  const clearBuybarListeners = () => {
    buybarObserver?.disconnect();
    buybarObserver = null;
    buybarSync = null;
    window.clearTimeout(buybarSyncTimer);
    buybarSyncTimer = 0;
    if (fallbackVisibilityHandler) {
      window.removeEventListener('scroll', fallbackVisibilityHandler);
      window.removeEventListener('resize', fallbackVisibilityHandler);
      fallbackVisibilityHandler = null;
    }
    if (mediaChangeHandler) {
      if (typeof mobileQuery.removeEventListener === 'function') {
        mobileQuery.removeEventListener('change', mediaChangeHandler);
      } else {
        mobileQuery.removeListener?.(mediaChangeHandler);
      }
      mediaChangeHandler = null;
    }
  };

  const setBuybarVisibility = (bar, visible) => {
    const shouldShow = Boolean(visible && mobileQuery.matches);
    bar.classList.toggle('is-visible', shouldShow);
    document.body.classList.toggle('has-fn-mobile-buybar', shouldShow);
  };

  const buildProductBuybar = () => {
    const productRoot = document.querySelector('[data-product-root]');
    const form = productRoot?.querySelector('[data-product-form]');
    const submit = form?.querySelector('.product-submit');
    const price = productRoot?.querySelector('[data-product-price-current]');

    if (!productRoot || !form || !submit || !price) return;

    document.querySelector('.fn-mobile-buybar')?.remove();
    document.body.classList.remove('has-fn-mobile-buybar');
    clearBuybarListeners();

    const bar = document.createElement('aside');
    const priceWrap = document.createElement('span');
    const priceLabel = document.createElement('span');
    const priceValue = document.createElement('strong');
    const button = document.createElement('button');

    bar.className = 'fn-mobile-buybar';
    bar.setAttribute('aria-label', 'Snel toevoegen aan winkelwagen');
    priceWrap.className = 'fn-mobile-buybar__price';
    priceLabel.textContent = 'Prijs';
    priceValue.textContent = price.textContent.trim();
    button.className = 'fn-mobile-buybar__button';
    button.type = 'button';
    button.textContent = 'In winkelwagen';
    button.setAttribute('aria-label', 'Voeg dit product toe aan de winkelwagen');

    priceWrap.append(priceLabel, priceValue);
    bar.append(priceWrap, button);
    document.body.append(bar);

    const sync = () => {
      const currentPrice = productRoot.querySelector('[data-product-price-current]');
      priceValue.textContent = currentPrice?.textContent.trim() || price.textContent.trim();
      button.disabled = submit.disabled;
      button.textContent = submit.disabled ? 'Niet beschikbaar' : 'In winkelwagen';
    };
    buybarSync = sync;

    button.addEventListener('click', () => {
      if (submit.disabled) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submit);
      } else {
        submit.click();
      }
    });

    let primaryActionVisible = true;
    const syncVisibility = () => setBuybarVisibility(bar, !primaryActionVisible);

    if (typeof IntersectionObserver === 'function') {
      buybarObserver = new IntersectionObserver((entries) => {
        primaryActionVisible = entries.some((entry) => entry.isIntersecting);
        syncVisibility();
      }, { threshold: .25 });
      buybarObserver.observe(submit);
    } else {
      fallbackVisibilityHandler = () => {
        const rect = submit.getBoundingClientRect();
        primaryActionVisible = rect.bottom >= 0 && rect.top <= window.innerHeight;
        syncVisibility();
      };
      window.addEventListener('scroll', fallbackVisibilityHandler, { passive: true });
      window.addEventListener('resize', fallbackVisibilityHandler, { passive: true });
      fallbackVisibilityHandler();
    }

    mediaChangeHandler = syncVisibility;
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', mediaChangeHandler);
    } else {
      mobileQuery.addListener?.(mediaChangeHandler);
    }
    sync();
  };

  const boot = () => buildProductBuybar();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('foodnet:variant-change', scheduleBuybarSync);
  document.addEventListener('wokora:vat-updated', scheduleBuybarSync);
  document.addEventListener('shopify:section:load', buildProductBuybar);
})();
